import View from './view';
import {Props} from './model';
import {useSelector} from 'react-redux';
import {holderProfileSelector, profileUscSelector} from '../../redux/selectors/profile';

export const CardCodeScreen = ({onClose}: Props) => {
  const code = useSelector(profileUscSelector());
  const holderProfile = useSelector(holderProfileSelector());

  return View({
    code,
    isCampusParticipant: holderProfile?.campusParticipant ?? false,
    onClose,
  });
};
